/*
 *
 * DataRow
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 14-Oct-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import { Skeleton } from '@mui/material'
import PortalButton from '@nexidigital/portalbutton'
import PortalTooltip from '@nexidigital/portaltooltip'
import { Copy, Edit, Info } from '@nexidigital/iconlibrary'
import PortalIconButton from '@nexidigital/portaliconbutton'
import './DataRow.scss'

const DataRow = ({
  full,
  label,
  labelTooltip,
  placementTooltip,
  onClickTooltip,
  variantTooltip,
  isLoading,
  content,
  onEditClick,
  onEditCopy,
  img,
  altTextImg,
  icon,
  buttonIcon,
  labelButton
}) => (
  <Toggle>
    <div className={`dataRow ${full ? 'fullSize' : ''} ${onEditCopy ? 'onEditCopy' : ''}`}>
      {label !== ''
        ? (
          <h2 className='label'>
            {label}
            {labelTooltip && (
              <div className='tooltipBox'>
                <PortalTooltip
                  placement={placementTooltip}
                  onClick={onClickTooltip}
                  text={labelTooltip}
                  variant={variantTooltip}
                  icon={<Info size='16' type='line' />}
                />
              </div>
            )}
          </h2>
          )
        : (
            ''
          )}
      {isLoading
        ? (
          <Skeleton animation='wave' variant='rect' width='100%' />
          )
        : (
            content && (
              <div
                className={`contentDataRow ${onEditClick !== '' ? 'edit' : ''} ${img ? 'withImage' : ''} ${labelButton ? 'withButton' : ''
                }`}
              >
                {img && <img src={img} alt={altTextImg} />}
                {content}
                {labelButton && <PortalButton label={labelButton} size='small' textButton icon={buttonIcon} />}
                {onEditClick !== '' && (
                  <PortalIconButton
                    onClick={onEditClick}
                    icon={<Edit size='24' type='line' />}
                    type='standard'
                    size='extrasmall'
                  />
                )}
                {onEditCopy !== '' && (
                  <PortalIconButton
                    onClick={onEditCopy}
                    icon={<Copy size='24' type='line' />}
                    type='standard'
                    size='extrasmall'
                  />
                )}
                {icon && (
                  <div className='iconBox' role='presentation'>
                    {icon}
                  </div>
                )}
              </div>
            )
          )}
    </div>
  </Toggle>
)

DataRow.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placementTooltip: PropTypes.string,
  onClickTooltip: PropTypes.func,
  variantTooltip: PropTypes.string,
  isLoading: PropTypes.bool,
  onEditClick: PropTypes.func,
  onEditCopy: PropTypes.func,
  full: PropTypes.bool,
  img: PropTypes.string,
  altTextImg: PropTypes.string,
  icon: PropTypes.object,
  labelButton: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonIcon: PropTypes.object
}

DataRow.defaultProps = {
  // Add here some default propTypes values
  label: '',
  content: '',
  labelTooltip: '',
  placementTooltip: 'top',
  onClickTooltip: undefined,
  variantTooltip: 'withoutArrow',
  isLoading: false,
  onEditClick: '',
  onEditCopy: '',
  full: false,
  img: '',
  altTextImg: '',
  icon: '',
  labelButton: '',
  buttonIcon: null
}

export default DataRow
